import React from "react";
import { Shield } from "lucide-react";

const SPARK_COLORS = ["#FF007F", "#00F0FF", "#FFD700", "#B44DFF", "#FFFFFF"];
const SPARKS = Array.from({ length: 34 }, (_, i) => ({
  x: (i * 37.3) % 100, y: (i * 53.7 + 7) % 100, s: 2 + (i % 3), c: SPARK_COLORS[i % SPARK_COLORS.length], d: 2.6 + (i % 5) * 0.7, dl: (i * 0.41) % 4,
}));

// Twinkling dots + soft swinging spotlights for page backdrops.
export function PageSparkles({ beams = true }) {
  return (
    <>
      {beams && <div className="opacity-40"><div className="lp-beam lp-beam-l" /><div className="lp-beam lp-beam-r" /></div>}
      {SPARKS.map((p, i) => (
        <span key={i} className="lp-spark absolute rounded-full"
              style={{ left: `${p.x}%`, top: `${p.y}%`, width: p.s, height: p.s, background: p.c, boxShadow: `0 0 ${p.s * 3}px ${p.c}`, animationDuration: `${p.d}s`, animationDelay: `${p.dl}s` }} />
      ))}
    </>
  );
}

// Gradient-border glass panel (wrestler-page style).
export function Panel({ children, className = "", innerClass = "p-3", colors = ["#9D00FF", "#5B3BFF", "#00F0FF"], delay = 0, testId }) {
  return (
    <div data-testid={testId} className={`wr-rise rounded-2xl p-[2px] ${className}`}
         style={{ background: `linear-gradient(150deg, ${colors.join(", ")})`, animationDelay: `${delay}ms`, boxShadow: `0 0 22px ${colors[0]}33` }}>
      <div className={`relative h-full rounded-[14px] bg-[#110726]/90 backdrop-blur-md ${innerClass}`}>{children}</div>
    </div>
  );
}

export function RankOneBadge({ color = "#FFD700", testId }) {
  return (
    <div className="relative w-11 h-11 shrink-0 flex items-center justify-center" data-testid={testId}>
      <Shield size={44} strokeWidth={1.8} className="absolute inset-0 pvp-rank1-pulse" style={{ color, fill: `${color}33`, filter: `drop-shadow(0 0 8px ${color})` }} />
      <span className="relative font-num text-2xl leading-none mt-0.5" style={{ color, textShadow: `0 0 8px ${color}, 1px 1px 0 #000` }}>1</span>
    </div>
  );
}

export function SelectedTag() {
  return (
    <div className="absolute left-0 inset-y-0 w-5 flex items-center justify-center rounded-l-[10px] bg-[#FFE600]" data-testid="pvp-selected-tag">
      <span className="font-num text-[11px] tracking-[0.25em] text-[#0A051A] leading-none" style={{ writingMode: "vertical-rl", transform: "rotate(180deg)" }}>SELECTED</span>
    </div>
  );
}
